{
  "INBOX_MGMT": {
    "HEADER": "Posta",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Riconnetti",
      "FACEBOOK": "La connessione a Facebook è scaduta o è stata revocata. I messaggi inviati alla pagina non arrivano in questa casella di posta e le risposte possono non andare a buon fine. Una persona che gestisce la pagina Facebook deve fare clic su Riconnetti e accedere a Facebook.",
      "INSTAGRAM": "La connessione a Instagram è scaduta o è stata revocata. I messaggi inviati all'account non arrivano in questa casella di posta e le risposte possono non andare a buon fine. Fai clic su Riconnetti e accedi con lo stesso account Instagram. Un account diverso crea una nuova casella di posta.",
      "GOOGLE": "La connessione a Google è scaduta o è stata revocata. Le nuove email non arrivano in questa casella di posta e le risposte possono non andare a buon fine. Fai clic su Riconnetti e accedi a Google come {email}.",
      "MICROSOFT": "La connessione a Microsoft è scaduta o è stata revocata. Le nuove email non arrivano in questa casella di posta e le risposte possono non andare a buon fine. Fai clic su Riconnetti e accedi a Microsoft come {email}.",
      "ALLEGRO": "La connessione ad Allegro è scaduta o è stata revocata. I messaggi degli acquirenti non arrivano in questa casella di posta e le risposte possono non andare a buon fine. Fai clic su Riconnetti e accedi ad Allegro come venditore {seller}. Un account venditore diverso crea una nuova casella di posta.",
      "IMAP_LOGIN": "Il server di posta rifiuta l'accesso IMAP {login}. Le nuove email non arrivano in questa casella. Controlla il nome utente e la password IMAP nella scheda {tab} e salvali. Continuiamo a provare ad accedere e la casella si ripristina non appena l'accesso funziona.",
      "WHATSAPP": "La connessione a WhatsApp è scaduta o è stata revocata. Gli allegati dei clienti non arrivano in questa casella e le risposte possono non riuscire. Fai clic su Riconnetti, accedi a Facebook e seleziona di nuovo il numero {phone}."
    },
    "LIST": {
      "404": "Non ci sono caselle allegate a questo account.",
      "RECONNECT_REQUIRED": "Riconnessione necessaria"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Scegli il canale",
        "BODY": "Scegli il provider che vuoi integrare con la chat."
      },
      "INBOX": {
        "TITLE": "Crea casella",
        "BODY": "Autentica il tuo account e creare una casella."
      },
      "AGENT": {
        "TITLE": "Aggiungi agenti",
        "BODY": "Aggiungi agenti alla casella creata."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Sei pronto per iniziare!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nome casella",
        "PLACEHOLDER": "Inserisci il nome della tua casella di posta (ad esempio: Acme Inc)",
        "ERROR": "Inserisci un nome per la casella valido"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nome sito web",
        "PLACEHOLDER": "Inserisci il nome del tuo sito web (ad esempio: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Nome interno",
        "PLACEHOLDER": "Nome della casella come mostrato in questa dashboard",
        "ERROR": "Inserisci un nome interno univoco"
      },
      "FB": {
        "HELP": "PS: Accedendo, abbiamo accesso solo ai messaggi della tua pagina. Non potremo mai accedere ai tuoi messaggi privati.",
        "CHOOSE_PAGE": "Scegli una pagina",
        "CHOOSE_PLACEHOLDER": "Seleziona una pagina dalla lista",
        "INBOX_NAME": "Nome casella",
        "ADD_NAME": "Aggiungi un nome per la tua casella",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Scegli un valore",
        "CREATE_INBOX": "Crea casella"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continua con Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Collega il tuo profilo Instagram",
        "HELP": "Per aggiungere il tuo profilo Instagram come canale, devi autenticare il tuo profilo Instagram cliccando su 'Continua con Instagram' ",
        "ERROR_MESSAGE": "Si è verificato un errore durante la connessione a Instagram, riprova",
        "ERROR_AUTH": "Si è verificato un errore durante la connessione a Instagram, riprova",
        "NEW_INBOX_SUGGESTION": "Questo account Instagram era precedentemente collegato a una casella diversa ed è stato ora migrato qui. Tutti i nuovi messaggi appariranno qui. La vecchia casella non potrà più inviare o ricevere messaggi per questo account.",
        "DUPLICATE_INBOX_BANNER": "Questo account Instagram è stato migrato alla nuova casella del canale Instagram. Non potrai più inviare/ricevere messaggi Instagram da questa casella."
      },
      "TWITTER": {
        "HELP": "Per aggiungere il tuo profilo Twitter come canale, devi autenticare il tuo profilo Twitter cliccando su 'Accedi con Twitter' ",
        "ERROR_MESSAGE": "Si è verificato un errore nella connessione a Twitter, riprova",
        "TWEETS": {
          "ENABLE": "Crea conversazioni dai Tweet menzionati"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canale sito web",
        "DESC": "Crea un canale per il tuo sito web ed inizia a sostenere i tuoi clienti tramite il nostro widget per siti web.",
        "LOADING_MESSAGE": "Creazione del canale di supporto sito web",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar del canale"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL del webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Inserisci un URL valido"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Dominio del sito",
          "PLACEHOLDER": "Inserisci il dominio del tuo sito web (es: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Intestazione di benvenuto",
          "PLACEHOLDER": "Ciao!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Titolo di benvenuto",
          "PLACEHOLDER": "Rendiamo semplice connetterci con noi. Chiedete qualsiasi cosa o condividete il vostro feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Messaggio di saluto del canale",
          "PLACEHOLDER": "Acme Inc, in genere, risponde in poche ore."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Abilita messaggio di benvenuto sul canale",
          "HELP_TEXT": "Invia automaticamente un messaggio di benvenuto quando viene creata una nuova conversazione.",
          "ENABLED": "Abilitato",
          "DISABLED": "Disabilitato"
        },
        "REPLY_TIME": {
          "TITLE": "Imposta tempo di risposta",
          "IN_A_FEW_MINUTES": "In pochi minuti",
          "IN_A_FEW_HOURS": "In poche ore",
          "IN_A_DAY": "In un giorno",
          "HELP_TEXT": "Questo tempo di risposta verrà visualizzato sul widget della live chat"
        },
        "WIDGET_COLOR": {
          "LABEL": "Colore del widget",
          "PLACEHOLDER": "Aggiorna il colore del widget utilizzato nel widget"
        },
        "SUBMIT_BUTTON": "Crea casella",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di creare un canale del sito web, si prega di riprovare"
        }
      },
      "TWILIO": {
        "TITLE": "Canale Twilio SMS/WhatsApp",
        "DESC": "Integra Twilio e inizia a supportare i tuoi clienti tramite SMS o WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID dell'account",
          "PLACEHOLDER": "Inserisci il tuo SID Account Twilio",
          "ERROR": "Questo campo è obbligatorio"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Questo campo è obbligatorio"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Questo campo è obbligatorio"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Servizio messaggi SID",
          "PLACEHOLDER": "Inserisci il tuo servizio di messaggistica SID di Twilio",
          "ERROR": "Questo campo è obbligatorio",
          "USE_MESSAGING_SERVICE": "Usa un servizio di messaggistica Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Tipo di canale",
          "ERROR": "Seleziona il tipo di canale"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token di autenticazione",
          "PLACEHOLDER": "Inserisci il tuo token di autenticazione Twilio",
          "ERROR": "Questo campo è obbligatorio"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nome casella",
          "PLACEHOLDER": "Inserisci un nome della casella",
          "ERROR": "Questo campo è obbligatorio"
        },
        "PHONE_NUMBER": {
          "LABEL": "Numero di telefono",
          "PLACEHOLDER": "Inserisci il numero di telefono dal quale verrà inviato il messaggio.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "URL di callback",
          "SUBTITLE": "È necessario configurare l'URL di callback del messaggio in Twilio con l'URL menzionato qui."
        },
        "SUBMIT_BUTTON": "Crea un canale Twilio",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di autenticare le credenziali di Twilio, riprova"
        }
      },
      "SMS": {
        "TITLE": "Canale SMS",
        "DESC": "Inizia a supportare i tuoi clienti tramite SMS.",
        "PROVIDERS": {
          "LABEL": "Provider API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Larghezza di banda",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di salvare il canale SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID Account",
            "PLACEHOLDER": "Inserisci l'id del tuo account di Bandwidth",
            "ERROR": "Questo campo è obbligatorio"
          },
          "API_KEY": {
            "LABEL": "Chiave API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Questo campo è obbligatorio"
          },
          "API_SECRET": {
            "LABEL": "Chiave API segreta",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Questo campo è obbligatorio"
          },
          "APPLICATION_ID": {
            "LABEL": "ID applicazione",
            "PLACEHOLDER": "Inserisci l'id della tua applicazione di Bandwidth",
            "ERROR": "Questo campo è obbligatorio"
          },
          "INBOX_NAME": {
            "LABEL": "Nome casella",
            "PLACEHOLDER": "Inserisci un nome della casella",
            "ERROR": "Questo campo è obbligatorio"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numero di telefono",
            "PLACEHOLDER": "Inserisci il numero di telefono dal quale verrà inviato il messaggio.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Crea un canale Bandwidth",
          "API": {
            "ERROR_MESSAGE": "Non siamo stati in grado di autenticare le credenziali di Bandwidth, riprova"
          },
          "API_CALLBACK": {
            "TITLE": "URL di callback",
            "SUBTITLE": "È necessario configurare l'URL di callback del messaggio in Bandwidth con l'URL menzionato qui."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Nome casella",
            "PLACEHOLDER": "Inserisci un nome per la casella",
            "ERROR": "Questo campo è obbligatorio"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numero di telefono",
            "PLACEHOLDER": "Inserisci il numero di telefono da cui verranno inviati i messaggi.",
            "ERROR": "Fornisci un numero di telefono valido che inizi con il segno `+`."
          },
          "SUBMIT_BUTTON": "Crea canale SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Non siamo stati in grado di creare il canale SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Nome casella",
            "PLACEHOLDER": "Inserisci un nome per la casella",
            "ERROR": "Questo campo è obbligatorio"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numero di telefono",
            "PLACEHOLDER": "Inserisci il numero di telefono da cui verranno inviati i messaggi.",
            "ERROR": "Fornisci un numero di telefono valido che inizi con il segno `+`."
          },
          "SUBMIT_BUTTON": "Crea canale DIDWW",
          "API": {
            "ERROR_MESSAGE": "Non siamo stati in grado di creare il canale DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Provider API",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "URL del webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Configurazione rapida con Meta",
          "DESC": "Verrai reindirizzato a Meta per accedere al tuo account WhatsApp Business. Avere l'accesso come amministratore renderà la configurazione semplice e veloce.",
          "BENEFITS": {
            "EASY_SETUP": "Nessuna configurazione manuale richiesta",
            "SECURE_AUTH": "Autenticazione sicura basata su OAuth",
            "AUTO_CONFIG": "Configurazione automatica di webhook e numero di telefono"
          },
          "SUBMIT_BUTTON": "Connetti con WhatsApp Business",
          "AUTH_PROCESSING": "Autenticazione con Meta in corso",
          "WAITING_FOR_BUSINESS_INFO": "Completa la configurazione aziendale nella finestra di Meta...",
          "PROCESSING": "Configurazione del tuo account WhatsApp Business in corso",
          "CANCELLED": "La registrazione a WhatsApp è stata annullata",
          "WAITING_FOR_AUTH": "In attesa di autenticazione...",
          "INVALID_BUSINESS_DATA": "Dati aziendali non validi ricevuti da Facebook. Riprova.",
          "SIGNUP_ERROR": "Si è verificato un errore di registrazione",
          "SDK_LOAD_ERROR": "Impossibile caricare l'SDK di Facebook. Riprova.",
          "AUTH_NOT_COMPLETED": "Autenticazione non completata. Riavvia il processo.",
          "SUCCESS_FALLBACK": "L'account WhatsApp Business è stato configurato correttamente",
          "RECONNECTED": "Canale WhatsApp ricollegato correttamente"
        },
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di salvare il canale WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canale API",
        "DESC": "Integra con il canale API e inizia a supportare i tuoi clienti.",
        "CHANNEL_NAME": {
          "LABEL": "Nome canale",
          "PLACEHOLDER": "Inserisci un nome del canale",
          "ERROR": "Questo campo è obbligatorio"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL del webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "URL del webhook"
        },
        "SUBMIT_BUTTON": "Crea un canale API",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di salvare il canale api"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Canale Salesforce",
        "DESC": "Integra con il canale Salesforce e inizia a supportare i tuoi clienti.",
        "CHANNEL_NAME": {
          "LABEL": "Nome canale",
          "PLACEHOLDER": "Inserisci un nome per il canale",
          "ERROR": "Questo campo è obbligatorio"
        },
        "API_BASE_URL": {
          "LABEL": "URL API Salesforce",
          "SUBTITLE": "Configura l'URL di base per la tua istanza Salesforce.",
          "PLACEHOLDER": "URL API Salesforce",
          "ERROR": "Questo campo è obbligatorio"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID per il tuo canale Salesforce.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "Questo campo è obbligatorio"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret per il tuo canale Salesforce.",
          "PLACEHOLDER": "*****",
          "ERROR": "Questo campo è obbligatorio"
        },
        "SUBMIT_BUTTON": "Crea canale Salesforce",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di salvare il canale Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL Webhook",
          "SUBTITLE": "Devi configurare l'URL del webhook in Salesforce con l'URL indicato qui."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Usa questo bearer token per l'autenticazione quando configuri il webhook in Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Sostituisci mittente email",
          "SUBTITLE": "Se impostato, questo indirizzo email verrà utilizzato come mittente per tutte le email in uscita al posto dell'email di origine della conversazione.",
          "PLACEHOLDER": "es. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Canale Allegro",
        "DESC": "Collega un account venditore Allegro e rispondi ai suoi messaggi dal Contact Center.",
        "CHANNEL_NAME": {
          "LABEL": "Nome casella",
          "SUBTITLE": "Il nome che gli agenti vedono per questa casella.",
          "PLACEHOLDER": "Inserisci un nome per la casella",
          "ERROR": "Questo campo è obbligatorio"
        },
        "SUBMIT_BUTTON": "Accedi con Allegro",
        "API": {
          "ERROR_MESSAGE": "Si è verificato un errore durante la connessione ad Allegro, riprova"
        },
        "SELLER_LOGIN": {
          "TITLE": "Accesso Allegro",
          "SUBTITLE": "L'account venditore di cui questa casella legge e risponde ai messaggi."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Canale Kaufland",
        "DESC": "Rispondi ai messaggi dei ticket che gli acquirenti ti inviano sul marketplace Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Nome canale",
          "PLACEHOLDER": "Inserisci un nome del canale",
          "ERROR": "Questo campo è obbligatorio"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "La Client Key (chiave client) di 32 caratteri dalla pagina delle impostazioni API del tuo account venditore Kaufland.",
          "PLACEHOLDER": "Chiave di 32 caratteri",
          "ERROR": "Inserisci la Client Key di 32 caratteri"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "La Secret Key (chiave segreta) di 64 caratteri che appartiene alla Client Key. Kaufland la mostra una sola volta e non la invia mai a questa pagina.",
          "PLACEHOLDER": "Chiave di 64 caratteri",
          "ERROR": "Inserisci la Secret Key di 64 caratteri"
        },
        "SUBMIT_BUTTON": "Crea canale Kaufland",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di salvare il canale Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Disconnesso",
          "MESSAGE": "Kaufland ha rifiutato queste chiavi API. Inserisci di nuovo la client key e la secret key per riconnettere questa casella."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Canale email",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Nome canale",
          "PLACEHOLDER": "Inserisci un nome del canale",
          "ERROR": "Questo campo è obbligatorio"
        },
        "EMAIL": {
          "LABEL": "email",
          "SUBTITLE": "Email dove i tuoi clienti inviano i ticket di supporto.",
          "PLACEHOLDER": "email"
        },
        "SUBMIT_BUTTON": "Crea un canale email",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di salvare il canale email"
        },
        "FINISH_MESSAGE": "Inizia a inoltrare le tue email al seguente indirizzo email."
      },
      "LINE_CHANNEL": {
        "TITLE": "Canale LINE",
        "DESC": "Integra con il canale LINE e inizia a supportare i tuoi clienti.",
        "CHANNEL_NAME": {
          "LABEL": "Nome canale",
          "PLACEHOLDER": "Inserisci un nome del canale",
          "ERROR": "Questo campo è obbligatorio"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID canale LINE",
          "PLACEHOLDER": "ID canale LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Chiave segreta canale LINE",
          "PLACEHOLDER": "Chiave segreta canale LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token canale LINE",
          "PLACEHOLDER": "Token canale LINE"
        },
        "SUBMIT_BUTTON": "Crea un canale LINE",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di salvare il canale LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL di callback",
          "SUBTITLE": "È necessario configurare l'URL del webhook nell'applicazione LINE con l'URL menzionato qui."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canale Telegram",
        "DESC": "Integra con il canale Telegram e inizia a supportare i tuoi clienti.",
        "BOT_TOKEN": {
          "LABEL": "Token bot",
          "SUBTITLE": "Configura il token del bot che hai ottenuto da Telegram BotFather.",
          "PLACEHOLDER": "Token bot"
        },
        "SUBMIT_BUTTON": "Crea canale Telegram",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di salvare il canale telegram"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Chiamate telefoniche",
        "DESC": "Imposta quali chiamate telefoniche verranno mostrate sotto questa casella.",
        "NAME": {
          "LABEL": "Nome casella",
          "SUBTITLE": "Scegli un nome facilmente identificabile."
        },
        "PHONE_NUMBER": {
          "LABEL": "Numero di telefono",
          "SUBTITLE": "Inserisci i numeri di telefono che appartengono a questa casella, puoi aggiungerne altri in seguito.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Crea casella chiamate telefoniche",
        "API": {
          "ERROR_MESSAGE": "Non siamo stati in grado di creare la casella"
        }
      },
      "AUTH": {
        "TITLE": "Scegli un canale",
        "DESC": "La chat supporta i widget di chat live, Facebook Messenger, WhatsApp, Email, ecc., come canali. Se vuoi costruire un canale personalizzato, puoi crearlo usando il canale API. Per iniziare, scegli uno dei canali qui sotto."
      },
      "AGENTS": {
        "TITLE": "Agenti",
        "DESC": "Qui puoi aggiungere agenti per gestire la tua casella appena creata. Solo questi agenti selezionati avranno accesso alla tua casella. Gli operatori che non fanno parte di questa casella non saranno in grado di vedere o rispondere ai messaggi in questa casella quando effettuano il login. <br> <b>PS:</b> come amministratore, se hai bisogno di accedere a tutte le caselle, dovresti aggiungerti come agente a tutte le caselle che crei.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Scegli gli agenti per la casella"
      },
      "DETAILS": {
        "TITLE": "Dettagli casella",
        "DESC": "Dal menu a tendina qui sotto, seleziona la pagina Facebook che vuoi collegare alla chat. Puoi anche assegnare un nome personalizzato alla tua casella per una migliore identificazione."
      },
      "FINISH": {
        "TITLE": "Azzeccato!",
        "DESC": "Hai completato con successo l'integrazione della tua pagina Facebook con la chat. La prossima volta che un cliente invia un messaggio alla tua pagina, la conversazione apparirà automaticamente nella tua casella.<br>Ti forniamo anche uno script per widget che puoi facilmente aggiungere al tuo sito web. Una volta dal vivo sul tuo sito web, i clienti possono inviarti messaggi direttamente dal tuo sito web senza l'aiuto di alcuno strumento esterno e la conversazione apparirà proprio qui, nella chat.<br>Bello, eh? Beh, cerchiamo di esserlo :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autenticazione con Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Qualcosa è andato storto, per favore aggiorna la pagina...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Impossibile creare la casella. Riprova.",
      "CREATING_CHANNEL": "Creazione della casella...",
      "TITLE": "Configura dettagli casella",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Aggiungi agenti",
      "ADD_AGENTS": "Aggiunta di agenti alla tua casella..."
    },
    "FINISH": {
      "TITLE": "La casella è pronta!",
      "MESSAGE": "Ora puoi interagire con i tuoi clienti attraverso il nuovo canale. Buona assistenza",
      "BUTTON_TEXT": "Portami lì",
      "MORE_SETTINGS": "Altre impostazioni",
      "WEBSITE_SUCCESS": "Hai completato la creazione di un canale sito web. Copia il codice mostrato qui sotto e incollalo sul tuo sito. La prossima volta che un cliente usa la live chat, la conversazione apparirà automaticamente nella tua casella."
    },
    "REAUTH": "Riautorizza",
    "VIEW": "Visualizza",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Impostazioni della casella, aggiornate con successo",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Assegnazione automatica aggiornata correttamente",
        "ERROR_MESSAGE": "Impossibile aggiornare le impostazioni della casella. Riprova più tardi."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "da",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Nessuno"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "ENABLE_HMAC": {
        "LABEL": "Abilita"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Abilitato",
        "DISABLED": "Disabilitato"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Abilita sincronizzazione delle email in entrata"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Abilita dominio email personalizzato (servizio a pagamento)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Abilita elaborazione dei commenti Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Firma HTML",
        "SUB_TEXT": "Questa firma sarà aggiunta in fondo a ogni messaggio inviato da questa casella.",
        "HTML_CONTENT": "Codice HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} sarà sostituito con il nome dell'agente.\n{'{{'}email{'}}'} sarà sostituito con l'indirizzo email dell'agente che ha inviato l'email.\n{'{{'}position{'}}'} sarà sostituito con la posizione dell'agente.\n{'{{'}custom_line{'}}'} sarà sostituito con la riga personalizzata dell'agente.\n{'{{'}email_signature_picture{'}}'} sarà sostituito con l'URL dell'immagine della firma email dell'agente (non un tag immagine) — usalo come sorgente dell'immagine (l'attributo src di un tag img).",
        "PREVIEW": "Anteprima"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Firme per paese",
        "SUB_TEXT": "Una risposta riceve la firma del paese dell'acquirente.",
        "HELP": "Una risposta viene firmata in base al paese della conversazione: il negozio Kaufland, il marketplace dell'ordine Allegro oppure, in mancanza, la lingua in cui scrive l'acquirente. Se il paese non è noto o qui non ha una firma, viene usata la firma HTML qui sopra. I marketplace vietano i link al tuo sito web e i dati di contatto, quindi limitati a un saluto e a {'{{'}name{'}}'}.",
        "EMPTY": "Non hai ancora firme per paese, quindi le risposte usano la firma HTML qui sopra.",
        "COUNTRY": "Seleziona un paese",
        "ADD": "Aggiungi firma per paese",
        "REMOVE": "Rimuovi"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Prefisso di composizione del numero di telefono",
        "PLACEHOLDER": "Inserisci il prefisso per il corretto routing delle chiamate (es. *99)",
        "HELP_TEXT": "Questo prefisso sarà aggiunto automaticamente ai numeri di telefono dei contatti quando componi da questa casella."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Testo del pulsante «Risolvi più tardi»",
        "PLACEHOLDER": "es. Risolveremo questo argomento via email. Ora vorrei chiedere qualcos'altro.",
        "HELP_TEXT": "Testo del pulsante del widget con cui il visitatore lascia l'argomento corrente e chiede qualcos'altro. Se lasci il campo vuoto, verrà usato il testo predefinito nella lingua del visitatore."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Posticipa automaticamente le chiamate perse per X minuti",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Posticipa automaticamente le chiamate perse per un numero specificato di minuti. Lascia vuoto o 0 per disabilitare."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Risolvi una chiamata persa dopo X richiamate senza risposta",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Quando una chiamata persa è stata richiamata X volte senza che il cliente risponda, viene risolta automaticamente e viene aggiunta una nota privata. Lascia vuoto o 0 per disabilitare."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Suggerimenti di domande",
        "SUB_TEXT": "Configura domande predefinite che i clienti possono utilizzare per interagire con i tuoi agenti.",
        "QUESTIONS_LABEL": "Domande",
        "ADD_QUESTION": "Aggiungi domanda",
        "QUESTION": "Domanda",
        "REMOVE": "Rimuovi",
        "QUESTION_TEXT": "Testo visualizzato nel riquadro.",
        "QUESTION_TEXT_PLACEHOLDER": "Obbligatorio",
        "QUESTION_PAYLOAD": "Testo inviato al click.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opzionale",
        "SAVE": "Salva",
        "NO_BOT_MESSAGE": "Per generare ulteriori suggerimenti AI, collega un bot.",
        "BOT_CONNECTED_MESSAGE": "I suggerimenti di domande AI dal bot possono essere attivati nelle sue",
        "BOT_SETTINGS_LINK": "impostazioni"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Email alternative",
        "SUB_TEXT": "Indirizzi aggiuntivi che questa casella di posta deve trattare come propri quando riceve email inoltrate.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Aggiungi",
        "REMOVE": "Rimuovi",
        "EMPTY": "Nessuna email alternativa configurata.",
        "HELP_TEXT": "Quando arriva un'email con uno di questi indirizzi come destinatario, le risposte verranno inviate con lo stesso indirizzo come mittente. Assicurati che il tuo server SMTP in uscita consenta l'invio da questi indirizzi.",
        "SIGNATURE_LABEL": "Firma",
        "PRIMARY_SIGNATURE": "Principale (predefinita)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Firme aggiuntive",
        "SUB_TEXT": "Definisci qui firme aggiuntive, quindi assegnale alle email alternative qui sotto.",
        "OPTION": "Firma {number}",
        "ADD": "Aggiungi firma",
        "REMOVE": "Rimuovi",
        "HELP_TEXT": "Quando una risposta viene inviata da un'email alternativa, viene usata la firma assegnata anziché la firma della casella di posta. Le email alternative lasciate su «Principale (predefinita)» tornano alla firma della casella di posta."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Elimina",
      "AVATAR_DELETE_BUTTON_TEXT": "Elimina avatar",
      "DELETE_REQUESTED_TOOLTIP": "Questa casella è contrassegnata per l'eliminazione",
      "RESTORE_BUTTON_TEXT": "Ripristina",
      "CONFIRM": {
        "TITLE": "Conferma eliminazione",
        "MESSAGE": "Sei sicuro di voler eliminare ",
        "PLACE_HOLDER": "Digita {inboxName} per confermare",
        "YES": "Sì, elimina ",
        "NO": "No, conserva "
      },
      "API": {
        "SUCCESS_MESSAGE": "Casella eliminata con successo",
        "MARKED_FOR_DELETION_MESSAGE": "Casella contrassegnata per l'eliminazione",
        "RESTORE_SUCCESS_MESSAGE": "Casella ripristinata con successo",
        "ERROR_MESSAGE": "Impossibile eliminare la casella. Riprova più tardi.",
        "RESTORE_ERROR_MESSAGE": "Impossibile ripristinare la casella. Riprova più tardi.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar casella eliminata con successo",
        "AVATAR_ERROR_MESSAGE": "Impossibile eliminare l'avatar della casella. Riprova più tardi."
      }
    },
    "TABS": {
      "SETTINGS": "Impostazioni",
      "COLLABORATORS": "Collaboratori",
      "AUTOMATIC_PRIORITY": "Priorità automatica",
      "AUTOMATIC_LABELING": "Etichettatura automatica",
      "CONFIGURATION": "Configurazione",
      "CAMPAIGN": "Campagne",
      "PRE_CHAT_FORM": "Modulo pre-chat",
      "BUSINESS_HOURS": "Ore di lavoro",
      "WIDGET_BUILDER": "Costruttore Widget",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Impostazioni",
    "FEATURES": {
      "LABEL": "Funzionalità",
      "DISPLAY_FILE_PICKER": "Visualizza il selettore di file sul widget",
      "DISPLAY_EMOJI_PICKER": "Visualizza il selettore emoji sul widget",
      "ALLOW_END_CONVERSATION": "Consenti agli utenti di terminare la conversazione dal widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Mostra il pulsante 'Avvia una nuova conversazione' nell'intestazione del widget",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Nascondi il campo di input quando viene mostrato il pulsante avvia una nuova conversazione",
      "SHOW_HANDOFF_BUTTON": "Mostra il pulsante 'Trasferisci a un operatore' nell'intestazione del widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Consenti agli agenti di inviare messaggi quando il contatto è offline e la continuità email non è disponibile",
      "AUTO_CLOSE_OLD": "Contrassegna come risolte tutte le chiamate precedenti dallo stesso numero dopo che una viene risolta",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Assegna automaticamente le chiamate perse quando si effettua una chiamata in uscita"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script Messenger",
      "MESSENGER_SUB_HEAD": "Posiziona questo pulsante all'interno del tuo tag body",
      "INBOX_AGENTS": "Agenti",
      "INBOX_TEAMS": "Team",
      "INBOX_COOPERATORS": "Collaboratori",
      "SELECT_PLACEHOLDER": "Seleziona",
      "AGENTS_OR_TEAMS_INFO": "Puoi assegnare agenti o team - non entrambi contemporaneamente.",
      "AGENT_ASSIGNMENT": "Assegnazione conversazione",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Aggiorna le impostazioni di assegnazione della conversazione",
      "UPDATE": "Aggiorna",
      "ENABLE_EMAIL_COLLECT_BOX": "Abilita casella di raccolta email",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Abilita o disabilita la casella di raccolta email nella nuova conversazione",
      "AUTO_ASSIGNMENT": "Abilita assegnazione automatica",
      "ENABLE_CSAT": "Abilita CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Abilita CSAT su ogni messaggio",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Attiva/Disabilita il sondaggio CSAT (soddisfazione del cliente) dopo aver risolto una conversazione",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Abilita/Disabilita l'opzione di sondaggio CSAT per ogni messaggio inviato dagli agenti",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Abilita la continuità della conversazione via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Le conversazioni continueranno via email se l'indirizzo email del contatto è disponibile.",
      "RESPOND_FROM_EMAIL": "Rispondi da email",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Le email al cliente — sia le risposte che le trascrizioni della conversazione — vengono inviate utilizzando le impostazioni SMTP della casella email selezionata, dall'indirizzo selezionato (l'indirizzo della casella stessa o uno dei suoi alias), e le risposte del cliente arrivano tramite il suo indirizzo IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Le trascrizioni della conversazione vengono inviate utilizzando le impostazioni SMTP della casella email selezionata, dall'indirizzo selezionato (l'indirizzo della casella stessa o uno dei suoi alias), e le risposte arrivano tramite il suo indirizzo IMAP.",
      "SHOW_WELCOME_SCREEN": "Mostra schermata di benvenuto",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Mostra la schermata di benvenuto quando il widget viene aperto. Se disabilitato, il widget andrà direttamente alla vista conversazione.",
      "AUTO_CLOSE_PENDING": "Risolvi automaticamente le chat AI dopo (ore)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Risolvi automaticamente le chat AI dopo X ore di inattività.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Impostazioni della casella",
      "INBOX_UPDATE_SUB_TEXT": "Aggiorna le impostazioni della casella",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Abilita o disabilita l'assegnazione automatica di nuove conversazioni agli agenti aggiunti a questa casella.",
      "HMAC_VERIFICATION": "Convalida identità utente",
      "HMAC_DESCRIPTION": "Al fine di convalidare l'identità dell'utente, è possibile passare un `identifier_hash` per ogni utente. Puoi generare un hash HMAC sha256 usando il `identificatore` con la chiave mostrata qui.",
      "HMAC_ROTATE": {
        "BUTTON": "Ruota chiave",
        "TITLE": "Ruotare la chiave segreta?",
        "WARNING": "La chiave attuale viene revocata nell'istante in cui viene ruotata.",
        "WARNING_DETAIL": "Non c'è alcun periodo di sovrapposizione e non può essere ripristinata.",
        "IMPACT": "I tuoi server devono firmare gli utenti con la nuova chiave. Chiunque sia ancora firmato con quella precedente non supera la convalida. Se la convalida dell'identità è obbligatoria, non potrà avviare una conversazione.",
        "CONFIRM": "Ruota chiave",
        "CANCEL": "Annulla",
        "SUCCESS": "Chiave segreta ruotata con successo",
        "ERROR": "Impossibile ruotare la chiave segreta, riprova"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Forza la convalida identità utente",
      "HMAC_MANDATORY_DESCRIPTION": "Se abilitata, le richieste mancanti del file `identifier_hash` saranno respinte.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Forza una nuova conversazione a ogni caricamento del widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Se abilitato, aprire il widget in una nuova scheda o finestra avvia una nuova conversazione.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Dimentica il contatto quando viene avviata una nuova conversazione",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Se disabilitato, una nuova conversazione avviata dal widget mantiene il contatto precedente.",
      "INBOX_IDENTIFIER": "Identificatore casella",
      "INBOX_IDENTIFIER_SUB_TEXT": "Usa il token `inbox_identifier` mostrato qui per l'autenticazione dei tuoi client API.",
      "FORWARD_EMAIL_TITLE": "Inoltra all'email",
      "FORWARD_EMAIL_SUB_TEXT": "Inizia a inoltrare le tue email al seguente indirizzo email.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sincronizzazione email",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Abilita la sincronizzazione automatica e il download delle email in entrata da questa casella",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Dominio email personalizzato",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Abilita l'uso di un dominio email personalizzato per le email in uscita",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Puoi leggere di più qui.",
      "FACEBOOK_COMMENTS_TITLE": "Commenti Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Consenti messaggi dopo la risoluzione della conversazione",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Consenti agli utenti finali di inviare messaggi anche dopo la risoluzione della conversazione.",
      "WIDGET_STATUS_LABEL": "Stato widget",
      "WIDGET_STATUS_ENABLED": "Abilitato",
      "WIDGET_STATUS_BUSINESS_HOURS": "Abilitato durante l'orario di lavoro",
      "WIDGET_STATUS_DISABLED": "Disabilitato",
      "WIDGET_STATUS_HELP_TEXT": "Controlla quando il widget viene mostrato ai visitatori del tuo sito web",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Lingua sondaggio CSAT ed email",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Scegli la lingua per tutte le email ai clienti inclusi sondaggi CSAT, trascrizioni delle conversazioni e notifiche email",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Eredita dall'account",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Connessione WhatsApp",
        "SUBTITLE": "Come questa casella è collegata a WhatsApp.",
        "PROVIDER": "Fornitore",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Connesso tramite la registrazione integrata di Meta",
        "STATUS": "Stato",
        "CONNECTED": "Connesso",
        "RECONNECT_HINT": "Fai clic su Riconnetti nel banner qui sopra.",
        "PHONE_NUMBER": "Numero di telefono",
        "BUSINESS_ACCOUNT": "ID account WhatsApp Business",
        "OPEN_MANAGER": "Apri in WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID numero di telefono",
        "TEMPLATES": "Modelli di messaggio",
        "TEMPLATES_COUNT": "{approved} di {total} approvati",
        "TEMPLATES_SYNCED": "Ultima sincronizzazione: {date}",
        "TEMPLATES_NOT_SYNCED": "Non ancora sincronizzati",
        "MANAGE_TEMPLATES": "Gestisci modelli"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limite assegnazione automatica",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Inserisci un valore maggiore di 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limita il numero massimo di conversazioni da questa casella di posta che possono essere assegnate automaticamente ad un agente"
    },
    "SLA": {
      "TITLE": "Policy SLA",
      "SUB_TEXT": "Configura i tempi di risposta e risoluzione SLA per ciascun livello di priorità della conversazione.",
      "LOADING": "Caricamento policy SLA...",
      "FIELDS": {
        "ACTIVE": "Attivo",
        "TICKET_PRIORITY": "Priorità ticket",
        "FIRST_RESPONSE_TIME": "Tempo di prima risposta",
        "EVERY_RESPONSE_TIME": "Tempo di ogni risposta",
        "RESOLUTION_TIME": "Tempo di risoluzione",
        "PLACEHOLDER": "es. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Policy SLA aggiornate con successo.",
        "ERROR_MESSAGE": "Impossibile aggiornare le policy SLA. Riprova."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Priorità automatica",
      "SUB_TEXT": "Configura l'assegnazione automatica della priorità in base al contenuto della conversazione.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Avviso di fatturazione",
        "MESSAGE": "Ogni valutazione della priorità comporterà un addebito. Consulta i dettagli del tuo piano per informazioni sui prezzi."
      },
      "MODE": {
        "OFF": "Disattivato",
        "ALL_MESSAGES": "Attivo per tutti i messaggi in entrata",
        "FIRST_MESSAGE": "Attivo solo per il primo messaggio in entrata"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Configurazione livelli di priorità",
        "SUB_TEXT": "Configura quali livelli di priorità devono essere abilitati e le loro descrizioni. Fornisci criteri chiari affinché l'AI possa determinare quando assegnare questa priorità."
      },
      "DESCRIPTION_LABEL": "Descrizione",
      "DESCRIPTION_PLACEHOLDER": "Descrivi le conversazioni da contrassegnare con priorità {priority}",
      "SET_AS_DEFAULT": "Imposta come priorità predefinita",
      "MULTIPLE_DEFAULTS_WARNING": "Solo un livello di priorità dovrebbe essere impostato come predefinito. Deseleziona gli altri predefiniti."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Etichettatura automatica",
      "SUB_TEXT": "Configura l'assegnazione automatica delle etichette in base al contenuto della conversazione.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Avviso di fatturazione",
        "MESSAGE": "Ogni valutazione di etichettatura comporterà un addebito. Consulta i dettagli del tuo piano per informazioni sui prezzi."
      },
      "MODE": {
        "OFF": "Disattivato",
        "CONVERSATION_OPEN": "All'apertura della conversazione",
        "CONVERSATION_CLOSE": "Alla chiusura della conversazione",
        "ALL_MESSAGES": "Su ogni messaggio - indipendentemente dallo stato",
        "FIRST_MESSAGE": "Sul primo messaggio - indipendentemente dallo stato"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Configurazione etichette",
        "SUB_TEXT": "Configura quali etichette devono essere disponibili per l'assegnazione automatica e le loro descrizioni. Fornisci criteri chiari affinché l'AI possa determinare quando applicare questa etichetta."
      },
      "DESCRIPTION_LABEL": "Descrizione",
      "DESCRIPTION_PLACEHOLDER": "Descrivi le conversazioni da etichettare come {label}. Se lasci vuoto, verrà utilizzata la descrizione dell'etichetta.",
      "NO_LABELS_MESSAGE": "Nessuna etichetta trovata. Crea prima le etichette per abilitare l'etichettatura automatica.",
      "CREATE_LABELS_LINK": "Crea etichette"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Riautorizza",
      "SUBTITLE": "La tua connessione a Facebook è scaduta, ricollegati alla tua pagina Facebook per continuare i servizi",
      "MESSAGE_SUCCESS": "Riconnessione riuscita",
      "MESSAGE_ERROR": "Si è verificato un errore, riprova"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "I moduli di chat predefiniti consentono di acquisire le informazioni dell'utente prima di iniziare la conversazione con te.",
      "SET_FIELDS": "Campi del modulo Pre chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Campi",
        "LABEL": "Etichetta",
        "PLACE_HOLDER": "Segnaposto",
        "KEY": "Chiave",
        "TYPE": "Tipo",
        "REQUIRED": "Obbligatorio"
      },
      "ENABLE": {
        "LABEL": "Abilita il modulo pre chat",
        "OPTIONS": {
          "ENABLED": "Sì",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Messaggio pre chat",
        "PLACEHOLDER": "Questo messaggio sarebbe visibile agli utenti insieme al modulo"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "I visitatori devono fornire il proprio nome e indirizzo email prima di iniziare la chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Imposta la tua disponibilità",
      "SUBTITLE": "Imposta la tua disponibilità sul tuo widget live chat",
      "WEEKLY_TITLE": "Imposta le ore settimanali",
      "TIMEZONE_LABEL": "Seleziona fuso orario",
      "UPDATE": "Aggiorna le impostazioni dell'orario di lavoro",
      "TOGGLE_AVAILABILITY": "Abilita la disponibilità aziendale per questa casella",
      "UNAVAILABLE_MESSAGE_LABEL": "Messaggio non disponibile per i visitatori",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Abilita disponibilità per questo giorno",
        "UNAVAILABLE": "Non disponibile",
        "HOURS": "ore",
        "VALIDATION_ERROR": "L'orario di inizio deve essere prima dell'orario di chiusura.",
        "CHOOSE": "Scegli"
      },
      "ALL_DAY": "Tutti i giorni",
      "SAVE_TO_ALL": "Salva in tutte le caselle",
      "SAVE_TO_ALL_TITLE": "Copia orari di lavoro",
      "SAVE_TO_ALL_CONFIRM": "Le impostazioni di questo modulo (interruttore disponibilità, messaggio fuori sede, fuso orario e orari di lavoro) saranno copiate in tutte le altre caselle ad eccezione delle caselle email e telefoniche. Sei sicuro di voler continuare?",
      "SAVE_TO_ALL_CANCEL": "Annulla",
      "SAVE_TO_ALL_YES": "Sì, copia in tutte",
      "SAVE_TO_ALL_SUCCESS": "Orari di lavoro copiati con successo in tutte le altre caselle",
      "SAVE_TO_ALL_ERROR": "Impossibile copiare gli orari di lavoro nelle altre caselle"
    },
    "PHONE": {
      "TITLE": "Impostazioni telefono",
      "SUBTITLE": "Configura quali chiamate verranno mostrate sotto questa casella.",
      "UPDATE": "Salva impostazioni",
      "EDIT": {
        "SUCCESS_MESSAGE": "Impostazioni telefono aggiornate",
        "ERROR_MESSAGE": "Impossibile aggiornare le impostazioni del telefono"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Numeri di telefono",
        "SUBTITLE": "Inserisci i numeri di telefono che appartengono a questa casella.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Aggiungi un numero di telefono"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Imposta i dettagli IMAP",
      "NOTE_TEXT": "Per abilitare SMTP, configurare IMAP.",
      "UPDATE": "Aggiorna impostazioni IMAP",
      "TOGGLE_AVAILABILITY": "Abilita la configurazione IMAP per questa casella",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Impostazioni IMAP aggiornate con successo",
        "ERROR_MESSAGE": "Impossibile aggiornare le impostazioni IMAP"
      },
      "ADDRESS": {
        "LABEL": "Indirizzo",
        "PLACE_HOLDER": "Indirizzo (ad esempio: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Porta",
        "PLACE_HOLDER": "Porta"
      },
      "LOGIN": {
        "LABEL": "Accedi",
        "PLACE_HOLDER": "Accedi"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "ENABLE_SSL": "Abilita SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Imposta i dettagli SMTP",
      "UPDATE": "Aggiorna impostazioni SMTP",
      "TOGGLE_AVAILABILITY": "Abilita la configurazione SMTP per questa casella",
      "TOGGLE_HELP": "Abilitare SMTP aiuterà l'utente a inviare email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Impostazioni SMTP aggiornate con successo",
        "ERROR_MESSAGE": "Impossibile aggiornare le impostazioni SMTP"
      },
      "ADDRESS": {
        "LABEL": "Indirizzo",
        "PLACE_HOLDER": "Indirizzo (ad esempio: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Porta",
        "PLACE_HOLDER": "Porta"
      },
      "LOGIN": {
        "LABEL": "Accedi",
        "PLACE_HOLDER": "Accedi"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "DOMAIN": {
        "LABEL": "Dominio",
        "PLACE_HOLDER": "Dominio"
      },
      "ENCRYPTION": "Cifratura",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Apri modalità di verifica SSL",
      "AUTH_MECHANISM": "Autenticazione"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Recapito delle email (DNS)",
      "SUB_TITLE": "Controlliamo i record SPF, DKIM, DMARC e MX di {domain} ogni giorno lavorativo. Quando qualcosa fa sì che i server riceventi rifiutino le vostre risposte o le trattino come spam, gli amministratori ricevono un'email con la soluzione.",
      "RUN": "Esegui controllo",
      "RUN_SUCCESS": "Controllo DNS completato",
      "RUN_ERROR": "Impossibile eseguire il controllo DNS, riprovare",
      "NOT_CHECKED": "Non ancora controllato.",
      "CHECKED_AT": "Ultimo controllo: {time}.",
      "DNS_UNAVAILABLE": "L'ultimo controllo non ha ricevuto risposta dai name server del dominio. Il risultato qui sotto proviene dal controllo precedente.",
      "SENDER": {
        "SMTP": "Le risposte vengono inviate tramite {host}.",
        "PLATFORM": "Le risposte vengono inviate tramite i nostri server di posta."
      },
      "STATUS": {
        "OK": "Tutti i record sono a posto",
        "WARNING": "Alcuni record potrebbero essere migliorati",
        "ERROR": "Le risposte potrebbero non raggiungere i destinatari",
        "UNKNOWN": "Sconosciuto"
      },
      "SEVERITY": {
        "ERROR": "Problema",
        "WARNING": "Avviso"
      },
      "FIX": "Per risolvere, utilizzate questo record DNS:",
      "RECORD_TYPE": "Tipo",
      "RECORD_HOST": "Nome",
      "RECORD_VALUE": "Valore",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Manca il record SPF",
          "DESCRIPTION": "Il dominio non indica quali server possono inviare le sue email. Molti server di posta considerano quindi le vostre risposte come spam. Aggiungete un record SPF che autorizzi {sender}."
        },
        "spf_multiple": {
          "TITLE": "Il dominio ha {count} record SPF",
          "DESCRIPTION": "Un dominio può avere un solo record SPF. Se ce ne sono di più, i server riceventi ignorano SPF e spesso rifiutano la posta. Uniteli in un unico record."
        },
        "spf_not_authorized": {
          "TITLE": "SPF non autorizza il server che invia le vostre risposte",
          "DESCRIPTION": "Le vostre risposte vengono inviate tramite {sender}, ma il record SPF del dominio non lo include. Record attuale: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Il record SPF richiede troppe ricerche DNS",
          "DESCRIPTION": "I server riceventi smettono di controllare SPF dopo {limit} ricerche DNS, ma {sender}, che invia le vostre risposte, viene raggiunto solo dopo {lookups}. Le vostre risposte non superano SPF. Spostate {sender} all'inizio del record e rimuovete gli include che il dominio non utilizza più."
        },
        "spf_lookups_others": {
          "TITLE": "Alcuni mittenti nel record SPF superano il limite di ricerche",
          "DESCRIPTION": "Il record SPF richiede {lookups} ricerche DNS, i server riceventi si fermano a {limit}. Le vostre risposte vengono verificate in tempo e superano SPF, ma la posta di questi mittenti non lo supera: {senders}. Rimuovete gli include che il dominio non utilizza più."
        },
        "spf_malformed": {
          "TITLE": "Il record SPF è errato",
          "DESCRIPTION": "I server riceventi non riescono a leggere il record SPF del dominio, quindi non protegge le vostre risposte. Il problema si trova in: {terms}. Sostituite il record con quello corretto."
        },
        "dkim_missing": {
          "TITLE": "La firma DKIM non è configurata",
          "DESCRIPTION": "Non abbiamo trovato alcuna chiave DKIM in {selectors}. Senza di essa le vostre risposte non sono firmate e hanno più probabilità di finire nello spam. Attivate la firma DKIM per il dominio presso il vostro fornitore di posta."
        },
        "dmarc_missing": {
          "TITLE": "Manca il record DMARC",
          "DESCRIPTION": "I grandi provider di posta, come Gmail e Microsoft, si aspettano un record DMARC. Senza di esso le vostre risposte hanno più probabilità di finire nello spam."
        },
        "dmarc_fails": {
          "TITLE": "DMARC indica ai riceventi di rifiutare le vostre risposte",
          "DESCRIPTION": "La policy DMARC del dominio è \"{policy}\" e le vostre risposte non superano né SPF né DKIM, quindi i riceventi le rifiutano o le spostano nello spam. Correggete SPF e DKIM indicati sopra."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blocca le risposte inviate tramite i nostri server di posta",
          "DESCRIPTION": "Questa casella invia le risposte tramite i nostri server di posta, ma la policy DMARC del dominio è \"{policy}\", quindi i riceventi le rifiutano o le spostano nello spam. Configurate SMTP del vostro server di posta per questa casella."
        },
        "mx_missing": {
          "TITLE": "Il dominio non ha un record MX",
          "DESCRIPTION": "Senza un record MX nessuno può inviare email al dominio, quindi i clienti non possono rispondere alle vostre risposte."
        }
      }
    },
    "NOTE": "Nota: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar sito web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar eliminato con successo",
              "ERROR_MESSAGE": "Si è verificato un errore, riprova"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nome sito web",
          "PLACE_HOLDER": "Inserisci il nome del tuo sito web (ad esempio: Acme Inc)",
          "ERROR": "Inserisci un nome di sito valido"
        },
        "WELCOME_HEADING": {
          "LABEL": "Intestazione di benvenuto",
          "PLACE_HOLDER": "Ciao!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Titolo di benvenuto",
          "PLACE_HOLDER": "Rendiamo semplice connetterci con noi. Chiedete qualsiasi cosa o condividete il vostro feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Tempo di risposta",
          "IN_A_FEW_MINUTES": "In pochi minuti",
          "IN_A_FEW_HOURS": "In poche ore",
          "IN_A_DAY": "In un giorno"
        },
        "WIDGET_COLOR_LABEL": "Colore del widget",
        "WIDGET_BUBBLE_POSITION_LABEL": "Posizione bolla del widget",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Altezza massima dei messaggi non letti (px)",
          "PLACE_HOLDER": "Nessun limite",
          "HELP_TEXT": "Limita l'altezza massima della finestra dei messaggi non letti in pixel. Lascia vuoto per il comportamento predefinito (nessun limite)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Tipo bolla del widget",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chatta con noi",
          "LABEL": "Titolo del launcher della bolla del widget",
          "PLACE_HOLDER": "Chatta con noi"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Aggiorna impostazioni widget",
          "API": {
            "SUCCESS_MESSAGE": "Impostazioni widget aggiornate con successo",
            "ERROR_MESSAGE": "Impossibile aggiornare le impostazioni del widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Anteprima",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Sinistra",
          "RIGHT": "Destra"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Bolla espansa"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Predefinito",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "In genere risponde in pochi minuti",
        "IN_A_FEW_HOURS": "In genere risponde in poche ore",
        "IN_A_DAY": "In genere risponde in un giorno"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Avvia conversazione",
        "CHAT_INPUT_PLACEHOLDER": "Scrivi il tuo messaggio"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Siamo online",
          "OFFLINE": "Siamo offline in questo momento"
        },
        "USER_MESSAGE": "Salve",
        "AGENT_MESSAGE": "Ciao"
      },
      "BRANDING_TEXT": "Offerto da JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Sito web",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canale API",
      "PHONE": "Telefono SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
